import { h, render, Component } from 'preact';

export class ImageField extends Component {
	render(props, state) {
		const {
			file,
			width,
			height
		} = props;

		if(!file) {
			return null;
		}
		let source = "https://hazards.colorado.edu/api/v2/uploads/" + file.container + "/" + file.filename;
		return (
			<div class="uk-align-left crop">
				<img width="150" height="150" src={source} />
			</div>
		)
	}
}